export default "__VITE_ASSET__CLrP1$EH__"